import { VueModule } from '@Foundation/utilities';
import KeyIngredients from './code/Scripts/components/key-ingredients';

export default VueModule({
  components: {
    KeyIngredients
  }
});
